// This constants file contains values that relate to date formats
export const TIME_ONLY = 'hh:MM A';
export const DAY_AND_MONTH_ONLY = 'DD MMM';
export const FULL_DAY_MONTH_YEAR = 'DD MMMM YYYY';
export const FULL_DATE_AND_TIME = 'DD MMMM YYYY hh:MM A';
export const FULL_DAY_SHORTENED_MONTH_YEAR = 'DD MMM YYYY';
export const HYPHENATED_DAY_MONTH_AND_YEAR = 'DD-MM-YYYY';
export const YEAR_MONTH_AND_DAY = 'YYYYMMDD';
export const YEAR_ONLY = 'YYYY';